import { Box, Flex, TextLink } from '@modusign/design-system';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useSessionStorage } from 'react-use';

import { Modusign27h } from '@app/components/Logos';
import { HIDE_IDENTIFICATION_INLINE_ALERT_KEY } from '@app/constants/identification';
import { signOut } from '@app/store/account/sign-out/actions';

interface GlobalHeaderProps {
  hasSignOutButton?: boolean;
}

function GlobalHeader({ hasSignOutButton }: GlobalHeaderProps) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [, setHideIdentificationInlineAlert] = useSessionStorage<boolean>(
    HIDE_IDENTIFICATION_INLINE_ALERT_KEY
  );

  const handleLogOut = useCallback(() => {
    dispatch(signOut());
    setHideIdentificationInlineAlert(true);
    history.push('/authentication/signin');
  }, [dispatch, history, setHideIdentificationInlineAlert]);

  return (
    <Box
      bg="white"
      borderBottomColor="boxBorderNeutralBase"
      borderBottomStyle="solid"
      borderBottomWidth="1px"
      height="63px"
    >
      <Flex
        alignItems="center"
        height="63px"
        justifyContent="space-between"
        marginX="auto"
        maxWidth="960px"
        p={4}
      >
        <Link to="/">
          <Modusign27h />
        </Link>
        <Flex>
          {hasSignOutButton && (
            <TextLink mr={4} onClick={handleLogOut}>
              로그아웃
            </TextLink>
          )}
          <TextLink
            href="https://support.modusign.co.kr/"
            rel="noopener noreferrer"
            target="_blank"
          >
            고객센터
          </TextLink>
        </Flex>
      </Flex>
    </Box>
  );
}

export default GlobalHeader;
